import React from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';

interface CreateFraudTokenFormProps {
  tokenType: string;
  value: string;
  notes: string;
  onTokenTypeChange: (value: string) => void;
  onValueChange: (value: string) => void;
  onNotesChange: (value: string) => void;
}

export const CreateFraudTokenForm: React.FC<CreateFraudTokenFormProps> = ({
  tokenType,
  value,
  notes,
  onTokenTypeChange,
  onValueChange,
  onNotesChange,
}) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 2, paddingTop: 2 }}
    >
      <FormControl fullWidth>
        <InputLabel>Token Type</InputLabel>
        <Select
          value={tokenType}
          label="Token Type"
          onChange={(e) => onTokenTypeChange(e.target.value)}
        >
          <MenuItem value="email">Email</MenuItem>
          <MenuItem value="phone">Phone</MenuItem>
          <MenuItem value="message_text">Message Text</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Value"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        fullWidth
        helperText={
          tokenType === 'message_text'
            ? 'Case-insensitive text pattern to match in messages'
            : 'Exact value to match'
        }
      />
      <TextField
        label="Notes"
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        fullWidth
        multiline
        rows={3}
        helperText="Optional notes about this token"
      />
    </Box>
  );
};

export default CreateFraudTokenForm;
